<template>
    <MaintenanceChecker :checkedParts="checkedParts">
        <template slot="message">
            {{ $t('Virtual games are currently under maintenance') }}
        </template>
        <VirtualGamesSidebar
            :class="{ 'is-expanded': isSidebarExpanded }"
        />
        <div class="main virtual-games">
            <VirtualGameDetailContainer/>
        </div>
    </MaintenanceChecker>
</template>

<script>
    import { mapGetters } from 'vuex';
    import VirtualGameDetailContainer from '@modules/games/virtuals/VirtualGameDetailContainer';
    import { BannerCategory } from '@core/models/banners/enums';
    import { MaintenanceType } from '@core/models/country/enums';
    import VirtualGamesSidebar from '@app/modules/games/virtuals/components/Sidebar';
    import { SidebarId } from '@app/store/modules/ui/mobile/enums';

    export default {
        name: 'VirtualPage',
        data() {
            return {
                page: BannerCategory.virtual,
                checkedParts: [
                    MaintenanceType.virtual
                ]
            };
        },
        computed: {
            ...mapGetters('ui/mobile', ['isSidebarOpen']),
            isSidebarExpanded() {
                return this.isSidebarOpen(SidebarId.virtualGamesNav);
            }
        },
        components: {
            VirtualGameDetailContainer,
            VirtualGamesSidebar,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/pages/VirtualGameDetailPage.vue